import { SignupStore, signupStore } from './signup.store';
import React from 'react'
import { MobXProviderContext } from 'mobx-react'
import { ProjectsStore, projectsStore } from './projects.store'
import { DatasetsStore, datasetsStore } from './datasets.store'
import { PredictorsStore, predictorsStore } from './predictors.store'
import { DashboardStore, dashboardStore } from './dashboard.store'
import { MpoProjectsStore, mpoProjectsStore } from './mpoProjects.store'
import { FoldersStore, foldersStore } from './folders.store'
import { SharingStore, sharingStore } from './sharing.store'
import { ObjectsProgressStore, objectsProgressStore } from './objectsProgress.store'
import { UsersStore, usersStore } from './users.store'
import { EnterprisesStore, enterprisesStore } from './enterprises.store'
import { GroupsStore, groupsStore } from './groups.store'
import { RolesStore, rolesStore } from './roles.store'
import { UsageStore, usageStore } from './usage.store'
import { PermissionsStore, permissionsStore } from './permissions.store'
import { EnterpriseStore, enterpriseStore } from './enterprise.store'
import { PredictionStore, predictionStore } from './prediction.store'

import { BillingStore, billingStore } from './billing.store'
import { ObjectStore, objectStore } from './object.store'
import { WorkflowStore, workflowStore } from './workflow.store'
import { FileStoragesStore, fileStorages } from './fileStorages.store';


type StoreTypes = {
  projects: ProjectsStore
  datasets: DatasetsStore
  predictors: PredictorsStore
  dashboard: DashboardStore
  mpoProjects: MpoProjectsStore
  folders: FoldersStore
  sharing: SharingStore
  objectsProgressStore: ObjectsProgressStore,
  usersStore: UsersStore,
  enterprisesStore: EnterprisesStore,
  groupsStore: GroupsStore,
  rolesStore: RolesStore,
  usageStore: UsageStore
  permissionsStore: PermissionsStore
  enterpriseStore: EnterpriseStore
  predictionStore: PredictionStore
  billingStore: BillingStore
  objectStore: ObjectStore
  signupStore: SignupStore
  workflow: WorkflowStore
  fileStorages: FileStoragesStore
}

export const clearStore = () => {
  const stores = [
    projectsStore,
    datasetsStore,
    predictorsStore,
    dashboardStore,
    mpoProjectsStore,
    foldersStore,
    objectsProgressStore,
    usersStore,
    enterprisesStore,
    groupsStore,
    rolesStore,
    usageStore,
    permissionsStore,
    enterpriseStore,
    predictionStore,
    billingStore,
    objectStore,
    signupStore,
    workflowStore,
    fileStorages,
  ]
  stores.forEach((store) => store.reset())
}

export const createStore = () => {
  return {
    projects: projectsStore,
    datasets: datasetsStore,
    predictors: predictorsStore,
    dashboard: dashboardStore,
    mpoProjects: mpoProjectsStore,
    folders: foldersStore,
    sharing: sharingStore,
    objectsProgressStore,
    usersStore,
    enterprisesStore,
    groupsStore,
    rolesStore,
    usageStore,
    permissionsStore,
    enterpriseStore,
    predictionStore,
    billingStore,
    objectStore,
    signupStore,
    workflow: workflowStore,
    fileStorages: fileStorages,
  }
}

// @ts-ignore
export const useStore: () => StoreTypes = () => {
  const store = React.useContext(MobXProviderContext)
  if (!store) {
    // this is especially useful in TypeScript so you don't need to be checking for null all the time
    throw new Error('useStore must be used within a StoreProvider.')
  }
  return store
}
